<div
  class="
    theme-dark
    w-100
    p-1
    d-flex
    bg-0
    justify-content-between
    rounded
    wrapper
  "
  data-testid="wrapper"
>
  <pre
    class="p-2"
  ><code #code [attr.class]="_lang" data-testid="code"><ng-content></ng-content></code></pre>
  <button
    role="button"
    mat-icon-button
    color="primary"
    [cdkCopyToClipboard]="code.innerText"
  >
    <am-icon name="copy"></am-icon>
  </button>
</div>
